import * as React from 'react';
import { Box, Typography, useTheme } from "@mui/material";

import { tokens } from "../../theme";
import Header from "../../components/Header";

import {Tabs,Tab,AppBar} from "@mui/material";
import Etat from "../../components/Statistiques/EtatComptable/index";
import Benefice from "../../components/Statistiques/BeneficeMensuel/index";
import Stat from "../../components/Statistiques/StatistiquesPeriodique/index";
import Journal from "../../components/Statistiques/JournalOperations/index";
import "../index.css";

const Ventclients = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  
  const [value,setValue]=React.useState(0);
  const handleTabs=(r,val)=>{
    console.warn(val)
    setValue(val)
  }
  return (
    <Box className="gestion-devise-container">
      <Header title="STATISTIQUES DES BÉNÉFICES"  />
      <Box>
        <AppBar position='static' backgroundColor="#fffff" >
          <Tabs value={value} onChange={handleTabs} >
            <Tab label="État de comptable" />
            <Tab label="Bénéfice Mensuel"/>
            <Tab label="Statistiques périodiques"/>
            <Tab label="Journal des opérations"/>
          </Tabs>
        </AppBar>
        
      </Box>
        
      <Box className="gestion-devise-content">
         
      <TabPanel value={value} index={0}><Etat/></TabPanel>
      <TabPanel value={value} index={1}><Benefice/></TabPanel>
      <TabPanel value={value} index={2}><Stat/></TabPanel>
      <TabPanel value={value} index={3}><Journal/></TabPanel>
     
      </Box>
      
    </Box>
  );
  
};
const TabPanel = (props) => {
  const {children,value,index}=props;
  return (
    
      value===index && (
        <div>{children}</div>
      )
      
    
  );
};
export default Ventclients;
